/**
 * SeasonInProgressGate
 */
import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectSeasonValue } from '../../services/seasons/selectors';

interface Props {
    children: React.Node;
    completedAt?: ?string;
    Fallback?: React.Node;
}

export class SeasonInProgressGate extends React.PureComponent<Props> {
    render() {
        const { children, completedAt, Fallback } = this.props;
        if (completedAt) return Fallback || null;
        return children;
    }
}

const mapStateToProps = createStructuredSelector({
    completedAt: makeSelectSeasonValue('completedAt')
});

export default connect(mapStateToProps)(SeasonInProgressGate);
